import { render, staticRenderFns } from "./elementHeading.vue?vue&type=template&id=7ec50795&scoped=true&"
import script from "./elementHeading.vue?vue&type=script&lang=js&"
export * from "./elementHeading.vue?vue&type=script&lang=js&"
import style0 from "./elementHeading.vue?vue&type=style&index=0&id=7ec50795&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec50795",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VSheet,VTextarea})
